import {apttusActions, translate} from '../../services'
import { messageDispatcher } from '..'

const addMessage = ( dispatch, message ) => {
  messageDispatcher( dispatch ).addMessage( { timeout: 15000, messageType: 'confirmation', messageText: translate( message) } );
};

export const apttusDispatcher = dispatch => ( {
  saveToApttusCart: cartItems => dispatch( { type: apttusActions.SAVE, data: cartItems} )
} );